// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 808 ? "d0dec1b0" : chunkId) + "." + {"702":"f0ef3f15737ec170","808":"3aed6421907e6a5d"}[chunkId] + ".js";
};